module.exports = __webpack_public_path__ + "static/assets/0ae93a24d9a9ff93f550fa560883bf7b.svg";